<template>
    <div class="anchor-help-center">
        <xi-top></xi-top>
        <div class="center-wrapper">
            <div class="center-menu-wrapper">
                <router-link @click.native="menuIndex=0;showSub=false;" :class="{'top-menu-chosen': menuIndex === 0}" :to="{name: 'anchorAboutPlatform'}" class="center-menu-item">
                    <div class="sticker"></div><i class="icon icon-20 icon-help-center-about-platform"></i><span>了解平台</span>
                </router-link>
                <router-link @click.native="menuIndex=1;showSub=false;" :class="{'top-menu-chosen': menuIndex === 1}" :to="{name: 'beAnAnchor'}" class="center-menu-item">
                    <div class="sticker"></div><i class="icon icon-20 icon-help-center-be-an-anchor"></i><span>成为主播</span>
                </router-link>
                <router-link @click.native="menuIndex=8;showSub=false;" :class="{'top-menu-chosen': menuIndex === 8}" :to="{name: 'anchorLevelTips'}" class="center-menu-item">
                    <div class="sticker"></div><i class="icon icon-20 icon-help-center-anchor-level"></i><span>主播等级</span>
                </router-link>
                <router-link @click.native="menuIndex=2;showSub=false;" :class="{'top-menu-chosen': menuIndex === 2}" :to="{name: 'searchTask'}" class="center-menu-item">
                    <div class="sticker"></div><i class="icon icon-20 icon-help-center-task"></i><span>寻找任务</span>
                </router-link>
                <router-link @click.native="menuIndex=3;showSub=true;subMenuIndex=-1;" :class="{'top-menu-chosen': menuIndex === 3}" :to="{name: 'auditionTips'}" class="center-menu-item">
                    <div class="sticker"></div><i class="icon icon-20 icon-help-center-tips"></i><span>试音技巧</span>
                </router-link>


                <div v-if="showSub">
                    <router-link @click.native="menuIndex=3;subMenuIndex=0;" :to="{name: 'pickEquipment'}" :class="{'sub-menu-chosen': subMenuIndex === 0}" class="center-menu-sub-item">
                        <span>录音设备挑选</span>
                    </router-link>
                    <router-link @click.native="menuIndex=3;subMenuIndex=1;" :to="{name: 'announceTips'}" :class="{'sub-menu-chosen': subMenuIndex === 1}" class="center-menu-sub-item">
                        <span>有声播讲技巧</span>
                    </router-link>
                    <router-link @click.native="menuIndex=3;subMenuIndex=2;" :to="{name: 'audioPostProgress'}" :class="{'sub-menu-chosen': subMenuIndex === 2}" class="center-menu-sub-item">
                        <span>音频后期处理</span>
                    </router-link>
                </div>


                <router-link @click.native="menuIndex=4;showSub=false;" :class="{'top-menu-chosen': menuIndex === 4}" :to="{name: 'recordDemand'}" class="center-menu-item">
                    <div class="sticker"></div><i class="icon icon-20 icon-hlep-center-requirement"></i><span>录制要求</span>
                </router-link>
                <router-link @click.native="menuIndex=5;showSub=false;" :class="{'top-menu-chosen': menuIndex === 5}" :to="{name: 'anchorDataAnalysis'}" class="center-menu-item">
                    <div class="sticker"></div><i class="icon icon-20 icon-help-center-data"></i><span>数据分析</span>
                </router-link>
                <router-link @click.native="menuIndex=6;showSub=false;" :class="{'top-menu-chosen': menuIndex === 6}" :to="{name: 'popularize'}" class="center-menu-item">
                    <div class="sticker"></div><i class="icon icon-20 icon-help-center-broadcast"></i><span>推广</span>
                </router-link>
                <router-link @click.native="menuIndex=7;showSub=false;" :class="{'top-menu-chosen': menuIndex === 7}" :to="{name: 'earningClosing'}" class="center-menu-item">
                    <div class="sticker"></div><i class="icon icon-20 icon-help-center-gain"></i><span>收益结算</span>
                </router-link>
            </div>
            <div class="center-right">
                <router-view></router-view>
            </div>
        </div>
        <xi-footer></xi-footer>
    </div>
</template>
<script>
    import axios from 'axios';
    import XiFooter from '../../components/Footer.vue';
    import XiTop from '../../components/Top.vue';
    export default {
        components: {
          axios,
          XiFooter,
          XiTop
        },
        data() {
            return {
              menuIndex: 0,
              subMenuIndex: -1,
              showSub: false
            }
        },
        methods: {
          initMenuIndex() {
            const name = this.$route.name;
            if (name === 'anchorAboutPlatform') this.menuIndex = 0;
            else if (name === 'beAnAnchor') this.menuIndex = 1;
            else if (name === 'searchTask') this.menuIndex = 2;
            else if (name === 'auditionTips') {this.menuIndex = 3;this.showSub=true;this.subMenuIndex = -1}
            else if (name === 'pickEquipment') {this.menuIndex = 3;this.showSub=true;this.subMenuIndex = 0}
            else if (name === 'announceTips') {this.menuIndex = 3;this.showSub=true;this.subMenuIndex = 1}
            else if (name === 'audioPostProgress') {this.menuIndex = 3;this.showSub=true;this.subMenuIndex = 2}
            else if (name === 'recordDemand') this.menuIndex = 4;
            else if (name === 'dataAnalysis') this.menuIndex = 5;
            else if (name === 'popularize') this.menuIndex = 6;
            else if (name === 'earningClosing') this.menuIndex = 7;
            else if (name === 'anchorLevelTips') this.menuIndex = 8;
          }
        },
        computed: {

        },
        beforeMount() {
          this.initMenuIndex();
        },
        beforeUpdate() {
          this.initMenuIndex();
        }
    }

</script>
<style lang="sass" scoped>
    @import "../../../sass/help-center.scss";
    @import "../../../sass/icons.scss";
</style>



// WEBPACK FOOTER //
// AnchorHelpCenter.vue?29394504